module.exports = require("@ember/object/computed");